module.exports = __webpack_public_path__ + "img/advancesearch.d15a5b37.svg";